import { put, takeLatest, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import { Types, Creators as CategoryCreators } from '../../reducers/category';
import getState from '../../utils/getState';

function* setPaginationCategory() {
  try {
    const {
      category: { searchQuery },
    } = yield select(getState);

    yield put(
      CategoryCreators.setPaginationCategorySuccess({
        searchQuery: {
          ...searchQuery,
          offset: parseInt(searchQuery.getIn(['limit']), 10) + parseInt(searchQuery.getIn(['offset']), 10),
        },
        scrollTo: false,
      })
    );
    yield put(CategoryCreators.setSearchQueryRequest('offset', 1));
  } catch (error) {
    yield put(CategoryCreators.setPaginationCategoryError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.SET_PAGINATION_CATEGORY_REQUEST, setPaginationCategory);
}
